let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kifIe")).then(() => parcelRequire('8cYfx'));